<template>
  <div>

    <div v-if="both_kind_of_person">
      <recruiting-chart-create-status-person :people="applicants" :recruiting_campaign_id="recruiting_campaign_id">
      </recruiting-chart-create-status-person>
    </div>
    <div v-else>
      <div class="form-group">
        <label>{{ __('forms.RecruitingChart.person') }}</label>
        <select class="form-control" @change="onPersonChange($event.target.value)" required name="recruitingChart[person_id]">
            <option value=''>---</option>
            <option v-for="person in applicants" :key="person.id"  :value="person.id" >  
              {{ person.fullName }}
            </option>
        </select>
      </div>
      <div v-if="!canSubmit" class='alert alert-danger'>
          {{ __('forms.RecruitingChart.applicant_already_present') }}
      </div>

      <div class="form-group">
        <label>{{ __('forms.RecruitingChart.status') }}</label>
        <select class="form-control" required name="recruitingChart[status_id]">
            <option value=''>---</option>
            <option v-for="status in statuses" :key="status.id"  :value="status.id" >  
              {{ status.name }}
            </option>
        </select>
      </div>
    </div>

    <div class="form-buttons clear">
        <div class="form-buttons clear">
          <button v-if="canSubmit" type="submit" class="btn btn--green">
            {{ __('misc.save') }}
          </button>
        </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
 
    recruiting_campaign_id: {
      type: Number,
      required: true,
    },
    statuses: {
        type:Array,
        required:true,
    },
    applicants: {
      type: Array,
      required: true,
    },

    both_kind_of_person: {
      type: Boolean,
      required: true
    },


  },

  data() {
    return {
      canSubmit: true,
    }
  },

  methods: {

    onPersonChange(person_id) {

      axios.get("/recruiting-charts/check-presence-applicant/" + this.recruiting_campaign_id, {
        params: {
          person_id: person_id
        }
      })
        .then((response) => {
          this.canSubmit = !response.data;
        });
    },
  },

  mounted() {
  
  }
}
</script>

<style></style>
